<template>
  <popup-bg :show-lock="showLock">
    <div slot="custom-html">
      <div class="chat-title">
        <h2>资源添加</h2>
      </div>
      <div class="popup-addstudent-wrap">
        <el-form :model="editData" label-width="15%">
          <el-form-item v-if="showType" class="moreline" label="介绍人ID">
            <el-input style="width: 35%" v-model="editData.parent_id" disabled="true"></el-input>
          </el-form-item>
          <el-form-item v-if="showType" class="moreline" label="介绍人">
            <el-input v-model="editData.bind_name" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="editData.custom_name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="editData.crm_tel" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="微信">
            <el-input v-model="editData.crm_weixin" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="QQ">
            <el-input v-model="editData.crm_qq" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="咨询老师" class="moreline" v-show="teachers.advisory_teacher && (!isAdvisory || !managerOnlyAdmin)">
            <el-select v-model="editData.crm_sayer_str" filterable @change="sayerChange" placeholder="请选择">
              <el-option-group v-for="(group, k) in teachers.advisory_teacher" :key="k" :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"
                />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="意向国家" class="moreline">
            <el-select
              v-model="editData.custom_hope_country"
              clearable
              multiple
              placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道">
            <jm-channel v-model="editData" clearable filterable :is-all="false" :final.sync="channelFinal"/>
          </el-form-item>
          <div class="bluefire-common-btnarea">
            <el-button :loading="btnLock" @click="submit" state-key="fib.jiemo.net/h5/common/addStudent-确认添加"
                       :state-status="true">确认添加</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div slot="close-button">
      <slot name="close-button"></slot>
    </div>
  </popup-bg>
</template>
<script>
import {
  // jmAreaselect,
  jmChannel,
  // jmEducationSelect,
  // jmExamjpSelect,
  jmDictSelect
} from '@/components/tool';
import _ from 'lodash';
import popupBg from './popupBg';
import student from '@/pages/student/student';
import permissionMixin from '@/pages/student/permissionMixin';

export default {
  mixins: [student, permissionMixin],
  data() {
    return {
      btnLock: false,
      showType: false,
      ds: {},
      // channels: '',
      channelFinal: false,
      hope_country: [],
      editData: {
        custom_name: '',
        crm_tel: '',
        crm_weixin: '',
        crm_qq: '',
        custom_hope_country: [], // 意向国家
        // 渠道
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: '',
        crm_level_lv: 50,
        crm_sayer: -1,
        crm_manager: null,
        crm_sayer_str: '',
        create_person: '',
        parent_id: 0,
        bind_name: ''
      },
      isEdit: true
    };
  },
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default() {
        return {
          addFormType: 0
        };
      }
    }
  },
  components: {
    jmChannel,
    jmDictSelect,
    'popup-bg': popupBg
  },
  computed: {
    /**
     * 老师数据，重新打包传递给子组件用
     */
    teachers() {
      return {
        advisory_teacher: this.filterTeachers(this.ds.advisory_teacher)
      };
    }
  },
  methods: {
    submit() {
      // if (this.editData.custom_name === '') {
      //   this.$message({
      //     type: 'error',
      //     message: '请填写姓名'
      //   });
      //   return;
      // }
      if (this.editData.crm_tel === '' && this.editData.crm_weixin.trim() === '') {
        this.$message({
          type: 'error',
          // message: '请填写联系方式(手机、微信、QQ任一即可)'
          message: '必须填写微信或手机号'
        });
        return;
      }
      if (this.editData.custom_from === '') {
        this.$message({
          type: 'error',
          message: '请填写渠道来源'
        });
        return;
      }
      if (this.editData.custom_hope_country.length < 1) {
        this.$message({
          type: 'error',
          message: '请选择意向国家'
        });
        return;
      }
      if (!this.channelFinal) {
        this.$message({
          type: 'error',
          message: '渠道来源必须填写完全'
        });
        return;
      }
      // this.setChannels();
      this.btnLock = true;
      this.$http._post({
        url: '/index/student/save',
        data: this.editData
      }).then(() => {
        this.btnLock = false;
        this.$message({
          type: 'success',
          message: '资源添加成功'
        });
        this.$emit('update:showLock', false);
        this.clearData();
      }).catch(() => {
        this.btnLock = false;
      });
    },
    // setChannels() {
    //   this.editData.custom_from = this.channels.custom_from;
    //   this.editData.custom_from_sub = this.channels.custom_from_sub;
    //   this.editData.custom_from_thrid = this.channels.custom_from_thrid;
    //   this.editData.custom_from_fourth = this.channels.custom_from_fourth;
    //   this.editData.custom_from_fifth = this.channels.custom_from_fifth;
    //   this.editData.custom_hope_country = this.hope_country;
    // },
    clearData() {
      this.editData = {
        custom_name: '',
        crm_tel: '',
        crm_weixin: '',
        crm_qq: '',
        custom_hope_country: [], // 意向国家
        // 渠道
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: '',
        crm_level_lv: 50,
        crm_sayer: -1,
        crm_manager: null,
        crm_sayer_str: '',
      };
      this.ds = {};
      this.hope_country = [];
    },
    sayerChange(val) {
      this.editData.crm_sayer = val;
    },
    /**
     * 老师筛选
     * @author liushaochen
     * @param  {[type]} teachers   老师列表
     * @param  {Array}  teacherIds 剔除列表的老师数组
     * @return {[type]}            [description]
     */
    filterTeachers(teachers, teacherIds = []) {
      if (!teachers) {
        return teachers;
      }
      let currentTeachers = { ...teachers };
      Object.entries(currentTeachers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          // 超管
          if (t.userid === -1) {
            return true;
          }

          // 前筛咨询展示
          if (t.roleid === 161) {
            return true;
          }

          // 无效的老师
          if (teacherIds.length > 0 && teacherIds.indexOf(t.userid) === -1) {
            return false;
          }

          return (
            this.editData.custom_hope_country.indexOf(t.country) > -1 ||
            // 待激活咨询
            t.country === 1808 ||
            // 考培
            // t.country === 1868 ||
            // 英美和日韩中心共用老师
            ([-1, -2].indexOf(t.country) !== -1 &&
              _.intersection(this.editData.custom_hope_country, this.countryCode.concat(this.countryCode1)).length) ||
            // 星耀东大老师
            (t.country === -3 &&
              _.intersection(this.editData.custom_hope_country, this.countryCode2).length)
          );
        });
        currentTeachers[char] = teacher;
        if (teacher.length === 0) {
          delete currentTeachers[char];
        }
      });
      return currentTeachers;
    },
    async ShowBindUser() {
      // 增加
      if (this.options.addFormType > 0) {
        this.showType = true;
        this.editData.custom_from = 7106;
        this.editData.parent_id = this.options.addFormType;
        await this.$http._post({
          url: '/index/student/getNameByCrmId',
          data: { crm_id: this.editData.parent_id },
        }).then((data) => {
          this.editData.bind_name = data.data.name;
        });
        this.editData.custom_from_sub = 7109;
      } else {
        this.showType = false;
        this.editData.custom_from = '';
        this.editData.custom_from_sub = '';
      }
    },
  },
  watch: {
    showLock(v) {
      if (v) {
        this.editData.create_person = this.userInfo.userid;
        if (this.isAdvisory) {
          this.editData.crm_sayer = this.userInfo.userid;
        }
        this.editData.custom_hope_country = [];
        this.hope_country = [];
        if (this.userInfo.countries.length === 1 && this.isAdvisory && this.userInfo.countries[0] !== 0) {
          this.editData.custom_hope_country.push(this.userInfo.countries[0]);
        }
        this.ShowBindUser();
      }
    }
  },

  mounted() {
    this.editData = Object.assign({}, this.editData, this.options);
    this.getDatasource();
  }
};
</script>
<style>
  .popup-addstudent-wrap .el-form .el-form-item.moreline .el-form-item__label{
    line-height:18px;
  }
  .popup-addstudent-wrap .jm-channel-select .el-select{
    width: 100% !important;
    margin-right: 0;
    margin-bottom: 2vw;
  }
</style>
<style scoped>
  .chat-title{
    text-align: center;
    padding: 5vw 0;
  }
  .chat-title h2{
    font-size: 4.8vw;
  }
  .popup-addstudent-wrap{
    padding: 0 4vw;
    max-height: 72vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .popup-addstudent-wrap .el-form{
    margin-top: 0;
  }
  .popup-addstudent-wrap .el-form .el-form-item{
    margin-bottom: 2vw;
  }
  .popup-addstudent-wrap .el-form .el-form-item .el-select{
    width: 100%;
  }
</style>
